const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const AVAILABILITY_OPTIONS = {
    AVAILABLE: 'AVAILABLE',
    ERROR: 'ERROR',
};

const isCheckinAvailabilityForced = (value) => Object.values(AVAILABILITY_OPTIONS).includes(value);

const getMockOptions = () => ({
    forceCheckinAvailability: isCheckinAvailabilityForced(websiteConfigCollection.getCheckinService()),
    forceCheckinAvailable: websiteConfigCollection.getCheckinService() === AVAILABILITY_OPTIONS.AVAILABLE,
    forceCheckinError: websiteConfigCollection.getCheckinService() === AVAILABILITY_OPTIONS.ERROR,
    forceRequiresAdvancedPassengerInformation: websiteConfigCollection.isCheckinRequiresMoreInfo(),
    forceNoSeatsAvailable: websiteConfigCollection.isCheckinAvailableInsurances(),
    get anyMockForced() {
        return this.forceCheckinAvailability || this.forceRequiresAdvancedPassengerInformation;
    },
});

const requiredPassengerDetails = (mockOptions = {}) => {
    const req = mockOptions.forceRequiresAdvancedPassengerInformation;
    return {
        gender: false,
        dateOfBirth: req,
        locale: false,
        mobilePhone: false,
        email: false,
        citizenship: false,
        countryOfResidence: false,
        requiredContactDetails: {
            fullName: false,
            phone: false,
            relation: false,
        },
        requiredTravelDocumentDetails: {
            PASSPORT: {
                travelDocumentType: 'PASSPORT',
                number: req,
                issued: false,
                expiration: req,
                issuingCountry: req,
                monthsDocumentValidity: 3,
            },
            NATIONAL_ID: {
                travelDocumentType: 'NATIONAL_ID',
                number: req,
                issued: false,
                expiration: req,
                issuingCountry: req,
                monthsDocumentValidity: null,
            },
        },
        requiredArrivalDetails: {
            state: false,
            city: false,
            address: false,
            zip: false,
        },
        requiredTravelPermissions: null,
    };
};

const getMockValues = (mockOptions) => ({
    requiredPassengerDetails: () => requiredPassengerDetails(mockOptions),
    checkinAvailability: () => ({
        available: mockOptions.forceCheckinAvailable,
        requiresAdvancedPassengerInformation: mockOptions.forceRequiresAdvancedPassengerInformation,
        requiresTravelPermissions: false,
        checkInWindow: null,
        requiredPassengerDetails: requiredPassengerDetails(mockOptions),
    }),
    checkinStatus: () => {
        return mockOptions.forceCheckinError
            ? {
                checkinInformation: {sections: [{status: 'ERROR'}]},
                checkinStatusBool: false,
                checkinAvailable: true,
            }
            : {
                checkinInformation: null,
                checkinStatusBool: false,
                checkinAvailable: mockOptions.forceCheckinAvailable,
            };
    },
    checkinSeatsAvailabilityNoSeats: () => ({
        ancillaryOptionsContainer: {
            seatMapResultsResponse: [],
        },
    }),
});

function checkinRepositoryMock(checkinRepository) {
    console.warn('checkinRepositoryMock');
    const mockOptions = getMockOptions();
    const mockValues = getMockValues(mockOptions);
    const module = {};

    module.getCheckinAvailability = function getCheckinAvailability(bookingId) {
        return mockOptions.anyMockForced
            ? Promise.resolve(mockValues.checkinAvailability())
            : checkinRepository.getCheckinAvailability(bookingId);
    };

    module.getCheckinStatus = function getCheckinStatus(bookingId) {
        return mockOptions.anyMockForced
            ? Promise.resolve(mockValues.checkinStatus())
            : checkinRepository.getCheckinStatus(bookingId);
    };

    module.getCheckinData = function getCheckinData(bookingId, email) {
        return checkinRepository.getCheckinData(bookingId, email);
    };

    module.getCheckinSeatsAvailability = function getCheckinSeatsAvailability(bookingInfo) {
        return mockOptions.forceNoSeatsAvailable
            ? Promise.resolve(mockValues.checkinSeatsAvailabilityNoSeats())
            : checkinRepository.getCheckinSeatsAvailability(bookingInfo);
    };

    return module;
}

module.exports = {
    getMockOptions,
    factory: checkinRepositoryMock,
};
